import Separator from "./Separator";

type LabelProps = {
  title: string;
};
export default function SectionLabel({ title }: LabelProps): JSX.Element {
  return (
    <>
      <h2 className="section-title">{title}</h2>
      <Separator />
    </>
  );
}
